// extracted by mini-css-extract-plugin
module.exports = {"reportsRadio":"_2KW8a"};